import React from 'react'

const NotFound = () => {
    return (
        <div className="container">
                <div className="d-flex justify-content-center align-items-center vh-100">
                    <div className="display-2">
                        <div style={{
                            color : '#206040'
                        }}>
                        404 Gaada brooo....
                        </div>
                    </div>
              
                
                </div>                   
        </div>
    )
}

export default NotFound
